module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"connectDomain":"Connect to your domain","saveDomain":"Save","savedDomain":"Domain saved","enterYourDomain":"Enter your domain","enterOurDomain":"Enter domain","ifNotDomain":"If you don\u0027t have your own domain, you can use ours","deleteDomain":"Delete domain","instructionsDomain":"Domain connection instructions"}}')
  delete Component.options._Ctor
}
